import { NewsPost, NewsPostSummary, newsTeaser } from '@radevents/shared';

import { SITE_ORIGIN } from '../config/siteOrigin';

/** Schema.org NewsArticle for an article detail page. */
export function buildNewsArticleSchema(post: NewsPost) {
  return {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    headline: post.title,
    description: newsTeaser(post),
    ...(post.coverImageUrl ? { image: [post.coverImageUrl] } : {}),
    ...(post.publishedAt ? { datePublished: post.publishedAt } : {}),
    author: { '@type': 'Organization', name: post.authorName },
    publisher: { '@type': 'Organization', name: 'Radsport Events', url: SITE_ORIGIN },
    mainEntityOfPage: `${SITE_ORIGIN}/news/${post.slug}`,
  };
}

/** Schema.org ItemList for the news overview. */
export function buildNewsListSchema(posts: NewsPostSummary[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: posts.map((p, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      url: `${SITE_ORIGIN}/news/${p.slug}`,
      name: p.title,
    })),
  };
}
